module.exports = __webpack_public_path__ + "static/fipcahoywhale1-a0f49ee460943ac8c1aced81c355b03f.jpeg";